<template>
  <article class="page position-relative overflow-hidden" :id="'page-' + idx">

    <component
      :class="[ 'page-' + idx ]"
      :idx="idx"
      :is="'Title' + idx"
      :heading="data.heading"
      :subhead="data.subhead"
      :keyword="data.keyword"
      :numeral="data.numeral"
      :force-tween="forceTitleTween"
      :win-h-forced="winHForced"
      @tween-done="forceTitleTween = false"
    />

    <page-section
      v-for="(section, sectIdx) in data.sections"
      :key="idx.toString() + sectIdx"
      :idx="sectIdx"
      :class="[section.wrapClass]"
      :data="section"
      :style="[ sectIdx === data.sections.length - 1 && idx !== 7 ? { paddingBottom: bPad } : {} ]"
    />

    <component
      :idx="idx"
      :is="'Foot' + idx"
      :subhead="footer.subhead"
      :keyword="footer.keyword"
      :numeral="footer.numeral"
      :win-h-forced="winHForced"
      v-if="footer"
    />

    <div class="text-center conclusion-footer" v-else>
      <div class="position-relative download-wrap">
        <conclusion-vect class="overflow-hidden position-absolute d-block"/>
        <div
          class="position-relative w-100 d-flex flex-column align-items-center justify-content-center dl-txt top-pad centered-wrap">
          <p class="px-3 graph-copy title" v-html="data.foot.topTitle"></p>
          <p class="w-75 theme-sub white" v-html="data.foot.topDesc"></p>
          <a :href="data.foot.bottomURL" target="_blank" class="mt-5 adobe-clean-bold adobe-btn">Learn More</a>
          <p class="mt-5 w-75 px-3 body-copy white download-cta">
            <span v-html="data.foot.pdfCtaTxt"></span>
            <a class="white" :href="data.foot.pdfURL" target="_blank" v-html="data.foot.pdfDesc"></a>
          </p>
          <p v-if="isMobile" class="w-75 mt-4 theme-sub smaller white">SHARE REPORT</p>
          <Social v-if="isMobile" :shareToggle="false"></Social>
        </div>
      </div>

      <div class="content-wrap bottom-wrap pt-0">
        <div class="bottom-wrap-inner">
          <p class="theme-sub smaller white title">REFERENCES</p>
          <p class="mb-5 body-copy white sub-title">Mobile Moments by appearance</p>
          <p class="fine-print white reference" v-for="ref in data.foot.refs"
             v-if="(reportLen === 1 && ref.longOnly) || !ref.longOnly"
             v-html="ref.text"></p>
        </div>
      </div>
    </div>

  </article>
</template>

<script>
  import { footIntroH } from '@/lib/consts'
  import PageSection from '@/components/report/PageSection'
  import ConclusionVect from '@/components/report/footers/ConclusionVect'
  import Title0 from '@/components/report/titleVects/Title0'
  import Title1 from '@/components/report/titleVects/Title1'
  import Title2 from '@/components/report/titleVects/Title2'
  import Title3 from '@/components/report/titleVects/Title3'
  import Title4 from '@/components/report/titleVects/Title4'
  import Title5 from '@/components/report/titleVects/Title5'
  import Title6 from '@/components/report/titleVects/Title6'
  import Title7 from '@/components/report/titleVects/Title7'
  import Foot0 from '@/components/report/footers/Foot0'
  import Foot1 from '@/components/report/footers/Foot1'
  import Foot2 from '@/components/report/footers/Foot2'
  import Foot3 from '@/components/report/footers/Foot3'
  import Foot4 from '@/components/report/footers/Foot4'
  import Foot5 from '@/components/report/footers/Foot5'
  import Foot6 from '@/components/report/footers/Foot6'
  import Social from '@/components/report/content/Social'
  import StateMixin from '@/components/report/mixins/StateMixin'

  export default {
    name: 'Page',
    props: {
      data: { type: Object, required: true },
      idx: { type: Number, required: true },
      footer: { type: [ Object, Boolean ], required: true },
      winHForced: [ Number, Boolean ]
    },
    mixins: [ StateMixin ],
    data () { return { forceTitleTween: false, bPad: (footIntroH + 30) + 'px' } },
    beforeRouteUpdate ( t, f, n ) {
      this.forceTitleTween = true
      if ( !this.isMobile ) {
        this.$store.dispatch( 'setSideNavOnWhite', false )
        this.$store.dispatch( 'setDeskCtrlsOnWhite', false )
      }
      n()
    },
    mounted () {
      if ( !this.isMobile ) {
        this.$store.dispatch( 'setSideNavOnWhite', false )
        this.$store.dispatch( 'setDeskCtrlsOnWhite', false )
      }
    },
    components: {
      PageSection,
      ConclusionVect,
      Foot0,
      Foot1,
      Foot2,
      Foot3,
      Foot4,
      Foot5,
      Foot6,
      Title0,
      Title1,
      Title2,
      Title3,
      Title4,
      Title5,
      Title6,
      Title7,
      Social
    }
  }
</script>

<style lang="scss">
  @import "../../assets/scss/global/the_goods";
  @import "../../assets/scss/global/components/toggles-common";

  section.page-section:last-of-type {
    /*padding-bottom : viewport-scale(285);*/

    #page-3 & {
      background-color : transparent !important;
    }

    #page-7 & {
      padding-bottom : 0;
    }
  }

  article {
    background-color : #fafafa;
  }

  .conclusion-foot-vect, .dl-txt {
    top  : 0;
    left : 0;
  }

  .dl-txt.top-pad {
    padding : 22vh 0 10vh;

    @include screen-md-lg-xl {
      padding : 28vh 0 14vh;
    }
  }

  .conclusion-footer {

    .graph-copy.title {
      line-height : 2rem;
      font-size   : rem(28);
      width       : 85%;

      @include screen-md-lg-xl {
        font-size   : rem(38);
        line-height : rem(46);
      }
    }

    .white {
      color : $white;
    }

    .theme-sub {
      @include screen-md-lg-xl {
        font-size : rem(18);
      }
    }

    .theme-sub.smaller {
      font-size      : rem(12);
      text-transform : uppercase;
    }

    .social {
      width           : 50%;
      display         : flex;
      justify-content : center;
      align-items     : center;

      a {
        margin : 0 15px;
      }
    }

    .download-cta {
      @include screen-md-lg-xl {
        font-size : rem(20);
      }
    }

    .content-wrap {
      .title {
        font-size   : rem(14);
        text-align  : left;
        font-weight : 900;
        margin      : 0;
        line-height : 1.2rem;

        @include screen-md-lg-xl {
          font-size : rem(16);
        }
      }

      .sub-title {
        font-size   : rem(12);
        text-align  : left;
        line-height : 1rem;

        @include screen-md-lg-xl {
          font-size : rem(14);
        }
      }
    }
  }

  .adobe-btn {
    color           : $white;
    padding         : rem(14) rem(37) rem(15);
    background      : $adobe-blue;
    border-radius   : rem(24.5);
    text-decoration : none;
  }

  .bottom-wrap {
    background : linear-gradient(transparent, black 35%);
    z-index    : 10;
    position   : relative;

    @include screen-md-lg-xl {
      background : linear-gradient(transparent, black 40%);
    }

    &-inner {
      border-top  : 1px solid #979797;
      max-width   : 512px;
      padding-top : 50px;
      margin      : 0 auto;

      @include screen-md-lg-xl {
        margin : 100px auto 0 auto;
      }
    }
  }

  .reference {
    opacity : 0.7;

    @include screen-md-lg-xl {
      font-size : rem(14);
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/report/Page.vue